import React, { useMemo, useState, useRef } from 'react';

//Third party packages
import * as yup from 'yup';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form, Card, Row, Col, InputGroup } from 'react-bootstrap';

import 'react-toastify/dist/ReactToastify.css';
import TextInput from '../../../../Components/GenericInputText/TextInput';
import PreferencesSettings from 'src/Member/api/PreferencesSettings';
import PasswordRules from '../../../components/common/PasswordRules';
import { LoginSVG } from '../../../img/GlobalSVG';
import GenericButton from '../../../../Components/GenericButton/GenericButton';

import './ProfileInformation.scss';
const ChangePassword = ({
  currentStep,
  nextStep,
  schema,
  userData,
  formData,
  updateDetails,
}) => {
  const { t } = useTranslation();
  const formRef = useRef(null);

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { adminConfigData = {} } = useSelector((state) => state.user || {});
  const updateUserDetails = (values) => {
    const user = {
      UserType: userData.UserType,
      Oid: userData?.Oid,
      UserID: userData?.UserID,
      ForcePasswordReset: false,
      Password: values.newPassword,
      CurrentPassword: values.currentPassword,
      Status: userData?.Status,
    };

    updateDetails(user);
  };

  const reviewForm = (errorLen) => {
    if (errorLen) {
      formRef.current.elements.item(0).focus();
    }
  };

  return (
    <>
      <div className="profile-information-my-profile">
        <Card className="card-container">
          <div className="top-section">
            <div className="user-icon">
              {userData?.FirstName[0] + userData?.LastName[0]}
            </div>
            <div className="name-email-container">
              <div className="name">{`${userData?.FirstName}${
                userData?.MiddleName ? ' ' + userData?.MiddleName + ' ' : ' '
              }${userData?.LastName}`}</div>
              <div className="email">{userData?.UserID || '-'}</div>
            </div>
            <div className="user-type-data-container">
              <div className="heading">User Type</div>
              <div className="data">
                {userData?.UserType
                  ? userData?.UserType === 'Client'
                    ? 'Employer'
                    : userData?.UserType
                  : '-'}
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="heading">
              <Row>
                <Col md={8}>Change Password</Col>
              </Row>
            </div>
            <Row>
              <Col md={12}>
                <Formik
                  validationSchema={schema}
                  initialValues={{
                    newPassword: '',
                    confirmPassword: '',
                    currentPassword: '',
                  }}
                  onSubmit={(values, { resetForm }) => {
                    updateUserDetails(values);
                    resetForm();
                    nextStep();
                  }}
                >
                  {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    errors,
                    isValid,
                  }) => {
                    const isEnabled =
                      values.currentPassword?.length > 0 &&
                      values.newPassword?.length > 0 &&
                      !!isValid;

                    return (
                      <Form
                        className="change-password-container"
                        onSubmit={handleSubmit}
                        ref={formRef}
                      >
                        {/*Current Password Block starts here */}
                        <Form.Group className="form-block">
                          <TextInput
                            isRequired={true}
                            parentClassName="password-field"
                            label={t(
                              'member.pages.my_profile.labels.current_password',
                            )}
                            feedBackMessage={
                              touched.currentPassword && errors.currentPassword
                            }
                            append={
                              <InputGroup.Text>
                                <i
                                  onClick={() => {
                                    setShowCurrentPassword(
                                      !showCurrentPassword,
                                    );
                                  }}
                                  onKeyPress={() => {
                                    setShowCurrentPassword(
                                      !showCurrentPassword,
                                    );
                                  }}
                                  className="show-hide-password"
                                  //className={ `fa ${ showCurrentPassword ? 'fa-eye-slash' : 'fa-eye' } font-18 password-eye-icon` }
                                  aria-label={
                                    showCurrentPassword
                                      ? 'click to hide password'
                                      : 'click to show password'
                                  }
                                  aria-live="polite"
                                  aria-atomic={isLoading}
                                  tabIndex={0}
                                >
                                  {showCurrentPassword ? (
                                    <LoginSVG.DisplayPasswordSVG />
                                  ) : (
                                    <LoginSVG.HidePasswordSVG />
                                  )}
                                </i>
                              </InputGroup.Text>
                            }
                            inputProps={{
                              spellCheck: 'off',
                              autoCorrect: 'off',
                              autoComplete: 'off',
                              onBlur: (e) => {
                                handleBlur(e);

                                PreferencesSettings.setCurrentPassword(
                                  e.currentTarget.value,
                                );
                                setIsLoading(true);
                              },
                              onChange: (e) => {
                                handleChange(e);

                                PreferencesSettings.setCurrentPassword(
                                  e.currentTarget.value,
                                );
                              },
                              name: 'currentPassword',
                              id: 'currentPasswordFormGroup',
                              value: values.currentPassword,
                              type: showCurrentPassword ? 'text' : 'password',
                              isInvalid:
                                touched.currentPassword &&
                                errors.currentPassword,
                            }}
                            ariaInvalid={errors.currentPassword ? true : null}
                            ariaDescribedby="err_currentPassword"
                          />
                        </Form.Group>
                        {/*Current Password Block ends here */}

                        {/*New Password Block starts here */}
                        <Form.Group className="form-block">
                          <TextInput
                            isRequired={true}
                            parentClassName="password-field"
                            label={t(
                              'member.pages.my_profile.labels.new_password',
                            )}
                            feedBackMessage={
                              touched.newPassword && errors.newPassword
                            }
                            append={
                              <InputGroup.Text>
                                <i
                                  onClick={() => {
                                    setShowNewPassword(!showNewPassword);
                                  }}
                                  onKeyPress={() => {
                                    setShowNewPassword(!showNewPassword);
                                  }}
                                  className="show-hide-password"
                                  aria-label={
                                    showNewPassword
                                      ? 'click to hide password'
                                      : 'click to show password'
                                  }
                                  aria-live="polite"
                                  aria-atomic={isLoading}
                                  tabIndex={0}
                                >
                                  {showNewPassword ? (
                                    <LoginSVG.DisplayPasswordSVG />
                                  ) : (
                                    <LoginSVG.HidePasswordSVG />
                                  )}
                                </i>
                              </InputGroup.Text>
                            }
                            inputProps={{
                              spellCheck: 'off',
                              autoCorrect: 'off',
                              onBlur: (e) => {
                                handleBlur(e);
                                setIsLoading(true);
                              },
                              autoComplete: 'off',
                              name: 'newPassword',
                              id: 'newPasswordFormGroup',
                              onChange: handleChange,
                              value: values.newPassword,
                              type: showNewPassword ? 'text' : 'password',
                              isInvalid:
                                touched.newPassword && errors.newPassword,
                            }}
                            ariaInvalid={errors.newPassword ? true : null}
                            ariaDescribedby="err_newPassword"
                          />
                        </Form.Group>
                        {/*New Password Block ends here */}

                        {/*Password Rule starts here */}
                        <div className="password-rules-container">
                          <PasswordRules
                            touched={touched.newPassword}
                            fieldValue={values.newPassword}
                            rules={adminConfigData?.passwordRules}
                          />
                        </div>
                        {/*Password Rule ends here */}

                        {/*Confirm Password Block starts here */}
                        <Form.Group className="form-block">
                          <TextInput
                            isRequired={true}
                            parentClassName="password-field"
                            label={t(
                              'member.pages.my_profile.labels.confirm_password',
                            )}
                            feedBackMessage={
                              touched.confirmPassword && errors.confirmPassword
                            }
                            append={
                              <InputGroup.Text>
                                <i
                                  onClick={() => {
                                    setShowConfirmPassword(
                                      !showConfirmPassword,
                                    );
                                  }}
                                  onKeyPress={() => {
                                    setShowConfirmPassword(
                                      !showConfirmPassword,
                                    );
                                  }}
                                  className="show-hide-password"
                                  aria-label={
                                    showConfirmPassword
                                      ? 'click to hide password'
                                      : 'click to show password'
                                  }
                                  aria-live="polite"
                                  aria-atomic={isLoading}
                                  tabIndex={0}
                                >
                                  {showConfirmPassword ? (
                                    <LoginSVG.DisplayPasswordSVG />
                                  ) : (
                                    <LoginSVG.HidePasswordSVG />
                                  )}
                                </i>
                              </InputGroup.Text>
                            }
                            inputProps={{
                              spellCheck: 'off',
                              autoCorrect: 'off',
                              onBlur: (e) => {
                                handleBlur(e);
                                setIsLoading(true);
                              },
                              autoComplete: 'off',
                              onChange: handleChange,
                              name: 'confirmPassword',
                              id: 'confirmPasswordFormGroup',
                              value: values.confirmPassword,
                              type: showConfirmPassword ? 'text' : 'password',
                              isInvalid:
                                touched.confirmPassword &&
                                errors.confirmPassword,
                            }}
                            ariaInvalid={errors.confirmPassword ? true : null}
                            ariaDescribedby="err_confirmPassword"
                          />
                        </Form.Group>
                        {/*Confirm Password Block ends here */}

                        {/*Form Buttons Block starts here */}
                        {Object.keys(errors).length > 0 && (
                          <button
                            className="reviewFormErrors btn btn-secondary"
                            tabIndex={-1}
                            onClick={() =>
                              reviewForm(Object.keys(errors).length)
                            }
                          >
                            Fill Missing Form Data
                          </button>
                        )}
                        <Form.Group
                          className="form-block"
                          controlId="buttonsFormGroup"
                        >
                          <Form.Group
                            className="form-block-1"
                            controlId="buttonsFormGroup"
                          >
                            <Row className="row-border-top">
                              <Col className="d-flex justify-content-end">
                                {/*<GenericButton
                                  variant="link"

                                >
                                  <b>
                                    { t( 'label_cancel' ) }
                                  </b>
                                </GenericButton> */}

                                <GenericButton
                                  type="submit"
                                  buttonDisabled={!isEnabled}
                                  disable={!isEnabled}
                                  variant="primary"
                                >
                                  Continue
                                </GenericButton>
                              </Col>
                            </Row>
                          </Form.Group>
                        </Form.Group>
                        {/*Form Buttons Block ends here */}
                      </Form>
                    );
                  }}
                </Formik>
              </Col>
            </Row>
          </div>
        </Card>
      </div>
    </>
  );
};
export default ChangePassword;
